import { LIEN_PRIORITY_LABEL } from './Liabilities.constants';

export const getLiabilityPropertyTooltip = ({ propertyId, lienPriority }, propertyAddressById) => {
  const address = propertyId ? propertyAddressById[propertyId] : null;

  if (!address) {
    return null;
  }

  const lienLabel = LIEN_PRIORITY_LABEL[lienPriority];

  return lienLabel ? `${lienLabel} - ${address}` : address;
};
